<template>
  <div class="mod-coupon">
    <a-radio-group class="coupon-type" name="coupon-type" v-model="type" @change="onTypeChange">
      <a-radio value="TICKET">
        机票
      </a-radio>
      <a-radio value="LUGGAGE">
        行李
      </a-radio>
      <a-radio value="MEALS">
        餐食
      </a-radio>
      <!-- <a-radio value="ITINERARY">
        行程单
      </a-radio> -->
      <a-radio value="VIPHALL">
        贵宾厅
      </a-radio>
    </a-radio-group>
    <div class="list">
      <!-- <div class="loading" v-if="loading">
        <a-spin size="large" />
      </div> -->
      <a-spin :spinning="loading" size="large">
      <div class="empty" v-if="!data.list.length">
        暂无数据
      </div>
      <template v-else>
        <div class="coupon-list clearfix">
          <coupon
            v-for="coupon in dataBySort"
            :key="coupon.couponNumber"
            :data="coupon"
            :checked-able="false"
          ></coupon>
        </div>
        <a-pagination v-model="data.pagination.current" :total="data.pagination.total" :page-size="12" @change="onChange" />
      </template>
      </a-spin>
    </div>
  </div>
</template>

<script>
import Coupon from '@/components/coupon/coupon-ticket'
import _ from 'lodash'

export default {
  props: {
    data: {
      type: Object,
      default () {
        return {
          list: [],
          pagination: {
            current: 1,
            pageSize: 12,
            total: 0
          }
        }
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dataBySort () {
      return _.orderBy(this.data.list, ['couponAmount', 'validEndDate'], ['desc', 'asc'])
    }
  },
  data () {
    return {
      type: 'TICKET'
    }
  },
  methods: {
    onChange (page) {
      const { type } = this

      this.$emit('change', type, {
        current: page,
        pageSize: 12
      })
    },
    onTypeChange () {
      const { type } = this

      this.$emit('change', type, {
        current: 1,
        pageSize: 12
      })
    }
  },
  components: {
    Coupon
  }
}
</script>
